import { useEffect, useState } from 'react';

import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router';
import { useDispatch } from 'react-redux';

import { useLogout } from 'hooks';
import { getPatient } from 'store/patient/service';
import { getPath } from 'routes';
import { Loading } from 'components/Fetch';
import { useAppSelector } from 'hooks';

import Survey from './Survey';

const PatientSurveySession = () => {
  const dispatch = useDispatch();
  const { logout } = useLogout();
  const intl = useIntl();
  const navigate = useNavigate();
  const { surveyId, patientId } = useParams<{ surveyId: string; patientId: string }>();
  const patient = useAppSelector(({ patient }) => patient.data);
  const [surveyTitle, setSurveyTitle] = useState<string>('');
  const [surveyLoading, setSurveyLoading] = useState<boolean>(true);
  const [surveyCompleted, setSurveyCompleted] = useState<boolean>(false);

  const handleSurveyLoad = (title: string) => {
    setSurveyTitle(title);
    setSurveyLoading(false);
  };

  useEffect(() => {
    if (!patient && patientId) {
      dispatch(getPatient({ uid: patientId, usePatientApi: true }));
    }
  }, [dispatch, patientId, patient]);

  useEffect(() => {
    if (surveyCompleted) {
      navigate(getPath().patient.thankYou);
    }
  }, [surveyCompleted, logout, navigate]);

  return (
    <div className="h-100 overflow-hidden d-flex justify-content-center">
      <div className="survey-wrapper">
        {!surveyCompleted && (
          <>
            {!surveyLoading && surveyTitle && (
              <div className="text-lg font-weight-bold text-center p-4">
                {intl.formatMessage({ id: surveyTitle })}
              </div>
            )}
            <div className="survey-content">
              {patient && surveyId ? (
                <Survey
                  surveyId={surveyId}
                  onClose={() => setSurveyCompleted(true)}
                  onLoad={(data: any) => handleSurveyLoad(data.title)}
                />
              ) : (
                <Loading />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PatientSurveySession;
